import React, { Component, useEffect, useState } from 'react'
import { Form as Formiker, Field as Fieldmik, Formik, FieldArray } from 'formik';
import { connect } from 'react-redux';

import { Form as FormUi, Button, Segment, Container } from 'semantic-ui-react';
import cogoToast from 'cogo-toast';
import * as Yup from 'yup'

import AddTitleBar from '../../titleBar/add_titleBar';
import { MyInput } from '../../apiInputComponent/myInput';

import { getTyrePosition, createVehicleType, getVehicleType, updateVehicleType, getMappedTyre, updateTyrePosition } from '../../../redux/actions/vehicleTypeActions'
import Axios from 'axios'
import APP_CONSTANT from '../../../config/constants'

import TyrePositionDropdown from './tyrePositionDropdown';
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder'
import DeleteAxios from '../../axiosComponent/deleteAxios'


export const EditVehicleType = (props) => {

    const [mappedTyre, setMappedTyre] = useState([])
    const [tyrePositionData, setTyrePositionData] = useState([])
    const [mappedPositionIds, setMappedPositionIds] = useState([])
    console.log(mappedPositionIds,'mappedPositionIds')
    const [success, setsuccess] = useState(false)

    console.log(mappedTyre,'mappedTyre')


    useEffect(() => {
        const { vehicleTypeData } = props
        props.getVehicleType(props.match.params.id)
        let data = props.getTyrePosition()
        data.then((resp) => {
            setTyrePositionData(resp.resultSet)
            // setState({ tyrePositionData: resp.resultSet })
        }).catch((err) => {

        })
    }, [mappedTyre])

    useEffect(() => {
        if (props.match.params.id) {
            let mappedtyres = []

            let dataTest = props.getMappedTyre(props.match.params.id)
            // if (data) {
            dataTest.then((obj) => {
                // mappedtyres.push(obj.resultSet)
                if (obj) {
                    console.log(obj.resultSet, 'resul')
                    setMappedTyre(obj.resultSet)
                    obj.resultSet.forEach((object) => {
                        mappedPositionIds.push(object.positionId)
                    })
                    // setState({ mappedTyre: obj.resultSet })
                }
                return obj

            }).catch((err) => {

            })

        }
    }, [])


    const { vehicleTypeData, isLoading, updateVehicleType } = props
    const emptyTypeTyre = [
        {
            positionId: '',
            vehicleTypeTyrePositionMapId: ''
        }
    ]

    const initialValues = {
        vehicleTypeCode: vehicleTypeData ? vehicleTypeData[0].vehicleTypeCode : '',
        vehicleTypeName: vehicleTypeData ? vehicleTypeData[0].vehicleType : '',
        vehicleTypeTyre: mappedTyre.length > 0 ? mappedTyre : emptyTypeTyre,
        vehicleTypeId: props.match.params.id ? props.match.params.id : ''
    }

    const validationSchema = Yup.object({
        vehicleTypeCode: Yup.string().required("Required"),
        vehicleTypeName: Yup.string().required("Required"),
    })

   

    let handleDelete = () => {
        // console.log(object,'delete id')
        setsuccess(true)
            let id = props.match.params.id 
            DeleteAxios({
                url: `masters/vehicleTypeTyrePositionMapping`,
                deleteItems: {
                vehicleTypeId: id,
                // positionId:positionId
            },
            deleted: (data) => {
                if (data && data.status === 1) {
                    setTimeout(() => {
                        setsuccess(false)
                        props.agGridReact.props.reload(true)
                    }, 500);
                }
            }
        })

    }

    const onSubmit = (values) => {
        console.log(values, ' on submit valuess')
     
        const uploadData = (values) => {

            const upload = [] 
            values.vehicleTypeTyre.map((object, index) => {
                let temp = {}
                temp.vehicleTypeTyrePositionMapId = object.vehicleTypeTyrePositionMapId ? object.vehicleTypeTyrePositionMapId : '0'
                temp.positionId = object.positionId
                temp.tyrePosition = object.tyrePosition
                temp.vehicleTypeId = props.match.params.id
                upload[index] = temp
            })

            values.vehicleTypeTyre = upload
            values.vehTypeId = props.match.params.id

            return values;
        }


        console.log("Main Values b", uploadData(values))
        let vehicleUpdated = props.updateVehicleType(uploadData(values))
        vehicleUpdated.then((res) => {
            if (values.vehicleTypeTyre.length > 0) {
                let customerNumber = localStorage.getItem('customerNo')
                let userId = localStorage.getItem('userId')
                values.vehicleTypeTyre.forEach((obj) => {
                    let temp = {}
                    temp.vehicleTypeId = props.vehicleTypeData[0].vehicleTypeId
                    temp.positionId = obj.positionId
                    temp.prevPositionId = obj.positionId
                    temp.tyrePosition = obj.tyrePosition
                    temp.prevTyrePosition = obj.tyrePosition
                    temp.customerNumber = customerNumber
                    temp.userId = userId
                    props.updateTyrePosition(temp)
                })
            }
        }).catch((err) => {

        })
    }

    if (isLoading) {
        return <LoadingPlaceholder />
    } else {
        return <>
            <AddTitleBar Title="Vehicle Type" LinkName="/vehicle-type" />
            <Container fluid className="m-2">
                <Formik
                    initialValues={
                        initialValues
                    }
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}>

                    {({ touched, errors, values, isSubmitting, handleSubmit }) => (
                        <Formiker>

                            <Segment>
                                {console.log(initialValues, 'initialValues')}
                                <div className="ui form">
                                    <FormUi.Group inline>
                                        <FormUi.Field width={3}>
                                            <label className="labelName">Vehicle Type Code *</label>
                                        </FormUi.Field>
                                        <FormUi.Field>

                                            <Fieldmik
                                                name="vehicleTypeCode"
                                                autoComplete="off"
                                                component={MyInput}
                                                placeholder="Code"
                                                value={values.vehicleTypeCode}
                                                error={values.vehicleTypeCode ? false : true}
                                            />
                                            {touched.vehicleTypeCode && errors.vehicleTypeCode ? <div className="w3-tiny w3-text-red p-bold-600">{errors.vehicleTypeCode}</div> : ''}
                                        </FormUi.Field>

                                        <FormUi.Field width={1} />

                                        <FormUi.Field width={3}>
                                            <label className="labelName">Vehicle Type Name *</label>
                                        </FormUi.Field>
                                        <FormUi.Field>
                                            <Fieldmik
                                                name="vehicleTypeName"
                                                component={MyInput}
                                                error={values.vehicleTypeName ? false : true}
                                                placeholder="Name"
                                                value={values.vehicleTypeName}
                                            />
                                            {touched.vehicleTypeName && errors.vehicleTypeName ? <div className="w3-tiny w3-text-red p-bold-600">{errors.vehicleTypeName}</div> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    {console.log("Tryreiy Positiionf: ", values.vehicleTypeTyre)}

                                    <FormUi.Group inline>
                                        <FormUi.Field width={3}>
                                            <label className="labelName">Tyre Position</label>
                                        </FormUi.Field>

                                        <>
                                            <FieldArray name="vehicleTypeTyre">
                                                {({ push, remove }) =>
                                                    <React.Fragment>
                                                        <div style={{ display: "flex", flexDirection: "column", }}>

                                                            {values.vehicleTypeTyre && values.vehicleTypeTyre.length > 0 && values.vehicleTypeTyre.map((object, index) => (


                                                                <FormUi.Field width={3} style={{ marginTop: "8px" }} key={index} >
                                                                    {console.log(object,values,'obj val')}
                                                                    {/* <div onChange={() => { editTyrePosition(values, object) }}> */}
                                                                        <Fieldmik component={TyrePositionDropdown} handleDelete={handleDelete} tyrePositionData={tyrePositionData} error={values.vehicleTypeName ? false : true} name={`vehicleTypeTyre[${index}].positionId`} value={values.vehicleTypeTyre[index].positionId} />
                                                                        <Button
                                                                            icon="plus"
                                                                            color="blue"
                                                                            type="button"
                                                                            basic
                                                                            size="mini"
                                                                            onClick={() => push({ positionId: '' })} />
                                                                        <Button
                                                                            icon="trash"
                                                                            color="red"
                                                                            type="button"
                                                                            basic
                                                                            disabled={index > 0 ? false : true}
                                                                            size="mini"
                                                                            onClick={(data, val) => { remove(index); handleDelete(object) }} />
                                                                    {/* </div> */}
                                                                </FormUi.Field>


                                                            ))}
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            </FieldArray>
                                        </>
                                    </FormUi.Group>
                                </div>
                            </Segment>
                            <center>
                                <Button color="blue" type="submit">Submit</Button>
                            </center>
                        </Formiker>
                    )
                    }
                </Formik>
            </Container>

        </>
    }

}

const mapStatetoProps = (state) => ({
    vehicleTypeData: state.getVehicleType.vehicleTypeList.resultSet,
    isLoading: state.getVehicleType.isLoading
})

export default connect(mapStatetoProps, { updateTyrePosition, getTyrePosition, createVehicleType, getVehicleType, updateVehicleType, getMappedTyre })(EditVehicleType)